/* eslint-disable react/self-closing-comp */
/* eslint-disable arrow-body-style */
/* eslint-disable react/no-array-index-key */
/* eslint-disable class-methods-use-this */
import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { changeUserAuthStatus } from '../../DataStore/actions/searchFormActions';
import './css/Profile.css';
import {
  MAIN_PAGE,
  SLASH_DELIMITER,
  PROFILE,
  MY_ACCOUNT,
  MY_ORDERS,
  PERSONAL_ONFO,
  PERSONAL_TAB,
  ORDERS_TAB,
  NO_ORDERS_YET,
  PLAN_TRIP,
  PDOBRAT_TOUR,
  ORDER_WAIT_PAYMENT_STATUS,
  ORDER_WAIT_PAIMENT,
  ORDER_WAIT_APPROVAL_STATUS,
  ORDER_WAIT_APPROVAL,
  ORDER_APPROVED_STATUS,
  ORDER_APPROVED,
  ORDER_DECLINED_STATUS,
  ORDER_DECLINED,
  BYN_TEXT,
  PROFILE_ORDER_NUMBER,
  PROFILE_ORDER_DEPARTURE,
  PROFILE_ORDER_DEPARTURE_CITY,
  PROFILE_ORDER_TOURISTS,
  PROFILE_ORDER_ROOM,
  PROFILE_ORDER_MEAL,
  PROFILE_ORDER_PRICE,
  PROFILE_PEOPLE_MISSING,
  ORDER_WAIT_PAYMENT_HINT,
  ORDER_WAIT_APPROVAL_HINT,
  ORDER_APPROVED_HINT,
  ORDER_DECLINED_HINT,
} from '../../Utils/Constants/GlobalConstants';
import Tour from '../../images/tour-r.png';
import { ReactComponent as NoHotel } from '../../images/hotel-r.svg';
import {
  firstLetterInUpperCase,
  formatPrice,
  getDayText,
  getNightsTextNoRange,
  getTouristsTextActualizOrder,
} from '../../Utils/CommonUtils';
import { isOrderPeopleMissing } from '../../Utils/OrderUtil';
import { meals } from '../../Utils/Constants/Meals';
import PriceText from '../PriceText/PriceText';
import ProfileOrderModal from './ProfileOrderModal/ProfileOrderModal';

const mapStateToProps = (state) => ({ ...state });

class Profile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      orders: [],
      email: '',
      isLoggedIn: false,
      activeTab: ORDERS_TAB,
      selectedOrder: null,
      isOrderModalVisible: false,
    };

    this.orderModalNode = React.createRef();
  }

  componentDidMount() {
    const token = window.localStorage.getItem('accessToken');
    const { changeUserAuthStatus: changeUserAuthStatusAction } = this.props;
    axios
      .get('/api/user/data', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((userResult) => {
        const { data } = userResult;

        this.setState({
          orders: data.orders,
          email: data.email,
          isLoggedIn: true,
        });
      })
      .catch(() => {
        window.localStorage.removeItem('accessToken');
        window.localStorage.removeItem('email');
        window.localStorage.setItem('isUserLoggedIn', false);
        changeUserAuthStatusAction(false);
      });
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleOrderModalOutsideClick);
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }

  handleOrderModalClick = (order) => {
    const { isOrderModalVisible } = this.state;

    if (!isOrderModalVisible) {
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollbarWidth}px`;

      document.addEventListener(
        'click',
        this.handleOrderModalOutsideClick,
        false,
      );

      this.setState({ isOrderModalVisible: true, selectedOrder: order });
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';

      document.removeEventListener(
        'click',
        this.handleOrderModalOutsideClick,
        false,
      );

      this.setState({ isOrderModalVisible: false });
    }
  };

  handleOrderModalOutsideClick = (e) => {
    const modalNode = this.orderModalNode.current;

    // a clicked button may be already removed by the re-render (form -> cards)
    if (
      !modalNode ||
      !e.target.isConnected ||
      modalNode.contains(e.target) ||
      e.target.closest('.pr_order')
    ) {
      return;
    }

    this.handleOrderModalClick();
  };

  // the customer filled the buyer and tourists data in the order modal
  handleOrderUpdate = (order) => {
    const { orders } = this.state;

    this.setState({
      orders: orders.map((item) => (item.id === order.id ? order : item)),
      selectedOrder: order,
    });
  };

  // an archived order shows no status to the customer
  getOrderStatus = (order) =>
    (order.archived ? {} : this.getOrderStatusData(order.status));

  getOrderStatusData = (status) => {
    const statuses = {
      [ORDER_WAIT_PAYMENT_STATUS]: {
        text: ORDER_WAIT_PAIMENT,
        hint: ORDER_WAIT_PAYMENT_HINT,
        className: 'pr_status_wait_payment',
      },
      [ORDER_WAIT_APPROVAL_STATUS]: {
        text: ORDER_WAIT_APPROVAL,
        hint: ORDER_WAIT_APPROVAL_HINT,
        className: 'pr_status_wait_approval',
      },
      [ORDER_APPROVED_STATUS]: {
        text: ORDER_APPROVED,
        hint: ORDER_APPROVED_HINT,
        className: 'pr_status_approved',
      },
      [ORDER_DECLINED_STATUS]: {
        text: ORDER_DECLINED,
        hint: ORDER_DECLINED_HINT,
        className: 'pr_status_declined',
      },
    };

    return statuses[status] || { text: '', hint: '', className: '' };
  };

  getMealText = (meal) => {
    const mealData = meals.find((item) => item.name === meal);
    return mealData ? mealData.russianfull : meal;
  };

  renderOrderDetail = (label, value) => {
    if (!value) {
      return null;
    }

    return (
      <div className="pr_order_detail">
        <div className="gr_text_14">{label}</div>
        <div className="br_text_14">{value}</div>
      </div>
    );
  };

  renderOrders = (orders) =>
    orders.map((item) => {
      const backgroundImage = {
        backgroundImage: `url("${item.hotelImage}")`,
      };
      const statusData = this.getOrderStatus(item);
      const nights = parseInt(item.nightsCount, 10);
      const category = item.hotelCategory ? ` ${item.hotelCategory}*` : '';

      return (
        <button
          key={`order-${item.id}`}
          type="button"
          className="pr_order"
          onClick={() => this.handleOrderModalClick(item)}
        >
          <div className="pr_order_img_w">
            <NoHotel />
            <div style={backgroundImage} className="pr_order_img" />
          </div>

          <div className="pr_order_info">
            <div className="pr_order_top">
              <div className="gr_text_14">
                {`${PROFILE_ORDER_NUMBER}${item.externalId}`}
              </div>
              {statusData.text && (
                <div className={`pr_status ${statusData.className}`}>
                  {statusData.text}
                </div>
              )}
            </div>
            <div className="bm_text_20">
              {firstLetterInUpperCase(item.hotelName)}
              <span className="gr_text_16">{category}</span>
            </div>
            <div className="gr_text_14 mb_16">
              {`${item.resort}, ${item.countryTo}`}
            </div>

            <div className="pr_order_details">
              {this.renderOrderDetail(
                PROFILE_ORDER_DEPARTURE,
                `${getDayText(item.departureDate)}, ${getNightsTextNoRange(
                  nights,
                )}`,
              )}
              {this.renderOrderDetail(
                PROFILE_ORDER_DEPARTURE_CITY,
                item.departureCity,
              )}
              {this.renderOrderDetail(
                PROFILE_ORDER_TOURISTS,
                getTouristsTextActualizOrder(item),
              )}
              {this.renderOrderDetail(
                PROFILE_ORDER_ROOM,
                firstLetterInUpperCase(item.roomType),
              )}
              {this.renderOrderDetail(
                PROFILE_ORDER_MEAL,
                this.getMealText(item.meal),
              )}
            </div>

            {statusData.hint && (
              <div className="gr_text_14 pr_order_hint">{statusData.hint}</div>
            )}
            {isOrderPeopleMissing(item) && (
              <div className="pr_order_people bm_text_14">
                {PROFILE_PEOPLE_MISSING}
              </div>
            )}
          </div>

          <div className="pr_order_price">
            <div className="gr_text_14 mb_5">{PROFILE_ORDER_PRICE}</div>
            <div className="bb_text_22">
              <PriceText text={`${formatPrice(item.totalPriceByn)} ${BYN_TEXT}`} />
            </div>
            {item.originalPrice && (
              <div className="gr_text_14">
                <PriceText text={`${item.originalPrice} ${item.currency}`} />
              </div>
            )}
          </div>
        </button>
      );
    });

  render() {
    const {
      orders,
      email,
      isLoggedIn,
      activeTab,
      selectedOrder,
      isOrderModalVisible,
    } = this.state;
    const { userFirstLetter } = this.props;

    return (
      <div className="containerW pr_container">
        {isLoggedIn && (
          <div>
            <div className="pr_breadcrumbs">
              <Link className="gm_text_14" to="/">
                {MAIN_PAGE}
              </Link>
              <div className="hd_breadcrumb_delimiter">{SLASH_DELIMITER}</div>
              <div className="gm_text_14">{PROFILE}</div>
            </div>
            <div className="pr_content_w">
              <div className="pr_col1">
                <div className="pr_menu">
                  <button
                    type="button"
                    className={`pr_menu_item bb_text_18 mb_5 ${
                      activeTab === PERSONAL_TAB ? 'pr_menu_selected' : ''
                    }`}
                    onClick={() => {
                      this.setState({ activeTab: PERSONAL_TAB });
                    }}
                  >
                    {MY_ACCOUNT}
                  </button>
                  <button
                    type="button"
                    className={`pr_menu_item bb_text_18 mb_5 ${
                      activeTab === ORDERS_TAB ? 'pr_menu_selected' : ''
                    }`}
                    onClick={() => {
                      this.setState({ activeTab: ORDERS_TAB });
                    }}
                  >
                    {MY_ORDERS}
                  </button>
                </div>
              </div>
              <div className="pr_col2">
                {activeTab === PERSONAL_TAB && (
                  <div>
                    <div className="bm_text_32 mb_20">{PERSONAL_ONFO}</div>
                    <div className="bm_personal">
                      <div className="bm_pers_letter br_text_28">
                        {userFirstLetter}
                      </div>
                      <div className="bm_text_18">{email}</div>
                    </div>
                  </div>
                )}
                {activeTab === ORDERS_TAB && (
                  <div>
                    <div className="bm_text_32 mb_20">{MY_ORDERS}</div>
                    {orders && orders.length > 0 ? (
                      <div>{this.renderOrders(orders)}</div>
                    ) : (
                      <div className="pr_orders_not_found">
                        <img src={Tour} alt="" className="mb_16" />
                        <div className="bm_text_22">{NO_ORDERS_YET}</div>
                        <div className="bm_text_22 mb_25">{PLAN_TRIP}</div>
                        <Link to="/" className="wm_text_18 pr_home_nav">
                          {PDOBRAT_TOUR}
                        </Link>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        <ProfileOrderModal
          isVisible={isOrderModalVisible}
          modalNode={this.orderModalNode}
          handleModalClick={this.handleOrderModalClick}
          order={selectedOrder}
          statusData={
            selectedOrder ? this.getOrderStatus(selectedOrder) : {}
          }
          handleOrderUpdate={this.handleOrderUpdate}
        />
      </div>
    );
  }
}

Profile.propTypes = {
  changeUserAuthStatus: PropTypes.func.isRequired,
  userFirstLetter: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, { changeUserAuthStatus })(Profile);
